import React from 'react'
import { useSelector } from 'react-redux'

import { _isRecording, _classTitle } from 'store/selectors/Room'

import CtaComponent from './components/CtaComponent'
import SessionInformation from './components/Information'
import { Container } from './styles'

const Session = () => {
    const isRecording = useSelector(_isRecording)
    const classTitle = useSelector(_classTitle)

    const props = {
        isRecording,
        classTitle,
    }
    return (
        <Container isRecording={isRecording}>
            <SessionInformation {...props} />
            <CtaComponent {...props} />
        </Container>
    )
}

export default Session
